import { render } from "./SexTotal.vue?vue&type=template&id=744f746e"
import script from "./SexTotal.vue?vue&type=script&lang=js"
export * from "./SexTotal.vue?vue&type=script&lang=js"

import exportComponent from "E:\\DevWorkspaces\\WorkSpaces\\sts3.9.9\\ZhaoTong\\laborEmpWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__